<template>
    <div class="admin">
        <form style="margin-bottom:10px;">
            <a-row type="flex" justify="start">
                <a-col :span="8">
                    <a-row :gutter="10">
                        <a-col :span="11">
                            <a-input v-model="keyword" placeholder="请输入关键词" />
                        </a-col>
                        <a-col :span="3">
                            <a-button type="primary" @click="get_data()">搜索</a-button>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="2">
                    <a-button type="primary" @click="add_model=true,info_add={}" v-if="$Func.check_rank('car_add')">添加车型</a-button>
                </a-col>
            </a-row>
        </form>
        <a-table :columns="columns" :data-source="tableData" @change="change_filter" :loading="loading" :pagination="page" bordered>
            <template slot="operation" slot-scope="text, record">
                <a @click="()=>{update_data(record)}" v-if="$Func.check_rank('car_add')">编辑</a>
                <a-divider type="vertical" />
                <a @click="()=>{delete_data(record)}" v-if="$Func.check_rank('car_del')">删除</a>
            </template>
        </a-table>
        <a-drawer
          title="增加车型记录"
          :width="750"
          :maskStyle="{backgroundColor: '#00000010'}"
          :visible="add_model"
          :body-style="{ paddingBottom: '80px' }"
          @close="add_model=false"
           v-if="$Func.check_rank('car_add')"
        >
            <a-form-model :model="info_add" :rules="add_rules" layout="vertical" @submit="add_data" ref="add_form">
                <a-divider orientation="left">
                    车辆信息
                </a-divider>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="enterprise" prop="enterprise" label="企业名称">
							<a-input v-model="info_add.enterprise" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
						<a-form-model-item ref="type" prop="type" label="车辆型号">
							<a-input v-model="info_add.type" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="title" prop="title" label="车辆名称">
							<a-input v-model="info_add.title" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
						<a-form-model-item ref="brand" prop="brand" label="车辆品牌">
							<a-input v-model="info_add.brand" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="motor_type" prop="motor_type" label="电机类型">
							<a-input v-model="info_add.motor_type" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
						<a-form-model-item ref="motor_data" prop="motor_data" label="驱动电机峰值功率/转速/转矩（kW/r/min/N.m）">
							<a-input v-model="info_add.motor_data" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="total_weight" prop="total_weight" label="总质量(kg)">
							<a-input v-model="info_add.total_weight" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
						<a-form-model-item ref="curb_weight" prop="curb_weight" label="整备质量(kg)">
							<a-input v-model="info_add.curb_weight" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="max_speed" prop="max_speed" label="最高车速(km/h)">
							<!-- <a-input-number style="width: 200px" :parser="value => value.replace(/[^\d]/g, '')" v-model="info_add.max_speed" /> -->
							<a-input v-model="info_add.max_speed" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
						<a-form-model-item ref="range" prop="range" label="续航里程(km)">
							<!-- <a-input-number style="width: 200px" :parser="value => value.replace(/[^\d]/g, '')" v-model="info_add.range" /> -->
							<a-input v-model="info_add.range" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="ekg" prop="ekg" label="Ekg单位载质量能量消耗量（Wh/km·kg）">
							<a-input v-model="info_add.ekg" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
						<a-form-model-item ref="level" prop="level" label="车辆级别">
							<a-input v-model="info_add.level" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="8">
						<a-form-model-item ref="length" prop="length" label="长(mm)">
							<a-input v-model="info_add.length" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="8">
						<a-form-model-item ref="width" prop="width" label="宽(mm)">
							<a-input v-model="info_add.width" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="8">
						<a-form-model-item ref="height" prop="height" label="高(mm)">
							<a-input v-model="info_add.height" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-divider orientation="left">
                    电池信息
                </a-divider>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="bt_type" prop="bt_type" label="电池类型">
							<a-input v-model="info_add.bt_type" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
						<a-form-model-item ref="bt_weight" prop="bt_weight" label="电池包重量(kg)">
							<a-input-number style="width: 200px" :step="0.01" v-model="info_add.bt_weight" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="bt_density" prop="bt_density" label="电池系统能量密度(Wh/kg)">
							<a-input-number style="width: 200px" :step="0.01" v-model="info_add.bt_density" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
						<a-form-model-item ref="bt_capacity_load" prop="bt_capacity_load" label="储能装置总储电量(kwh)">
							<a-input-number style="width: 200px" :step="0.01" precision="2" v-model="info_add.bt_capacity_load" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="bt_brand" prop="bt_brand" label="电池包供应商">
							<a-input v-model="info_add.bt_brand" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
						<a-form-model-item ref="bt_structure" prop="bt_structure" label="电池包结构">
							<a-input v-model="info_add.bt_structure" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="bt_voltage" prop="bt_voltage" label="电池包电压(V)">
							<a-input-number style="width: 200px" :step="0.01" v-model="info_add.bt_voltage" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
						<a-form-model-item ref="bt_capacity" prop="bt_capacity" label="电池包容量(Ah)">
							<a-input-number style="width: 200px" :step="0.01" precision="2" v-model="info_add.bt_capacity" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="bt_voltage_mz" prop="bt_voltage_mz" label="电池包模组电压(V)">
							<a-input-number style="width: 200px" :step="0.01" v-model="info_add.bt_voltage_mz" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
						<a-form-model-item ref="bt_capacity_mz" prop="bt_capacity_mz" label="电池包模组容量(Ah)">
							<a-input-number style="width: 200px" :step="0.01" precision="2" v-model="info_add.bt_capacity_mz" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="bt_core_type" prop="bt_core_type" label="电芯类型细分">
							<a-input v-model="info_add.bt_core_type" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="bt_core_brand" prop="bt_core_brand" label="电池电芯品牌">
							<a-input v-model="info_add.bt_core_brand" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
						<a-form-model-item ref="bt_core_num" prop="bt_core_num" label="电池电芯数量(只)">
							<a-input-number style="width: 200px" :parser="value => value.replace(/[^\d]/g, '')" v-model="info_add.bt_core_num" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="bt_core_size" prop="bt_core_size" label="单个电芯尺寸(mm)">
							<a-input v-model="info_add.bt_core_size" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
						<a-form-model-item ref="bt_core_shape" prop="bt_core_shape" label="单个电芯形状">
							<a-input v-model="info_add.bt_core_shape" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="bt_core_capacity" prop="bt_core_capacity" label="单个电芯容量(Ah)">
							<a-input-number style="width: 200px" :step="0.01" precision="2" v-model="info_add.bt_core_capacity" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
						<a-form-model-item ref="bt_core_voltage" prop="bt_core_voltage" label="单个电芯电压(V)">
							<a-input-number style="width: 200px" :step="0.01" precision="2" v-model="info_add.bt_core_voltage" />
						</a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
						<a-form-model-item ref="bt_core_weight" prop="bt_core_weight" label="单个电芯重量(kg)">
							<a-input-number style="width: 200px" :step="0.01" precision="2" v-model="info_add.bt_core_weight" />
						</a-form-model-item>
                    </a-col>
                    <a-col :span="12">
						<a-form-model-item ref="bt_core_density" prop="bt_core_density" label="单个电芯能量密度(Wh/kg)">
							<a-input-number style="width: 200px" :step="0.01" precision="2" v-model="info_add.bt_core_density" />
						</a-form-model-item>
                    </a-col>
                </a-row>
				
                <div :style="{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: 1,
                }">
                    <a-button :style="{ marginRight: '8px' }" @click="add_model=false">
                        取消
                    </a-button>
                    <a-button type="primary" html-type="submit">
                        确定
                    </a-button>
                </div>
            </a-form-model>
        </a-drawer>
        <Pics />
    </div>
</template>

<script>
    import Func from '../../common/func';
    import Pics from '../../components/Pics';
    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            width: 80,
        },
        {
            title: '企业名称',
            dataIndex: 'enterprise',
            key: 'enterprise',
        },
        {
            title: '车辆型号',
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: '车辆名称',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: '创建时间',
            dataIndex: 'created',
            key: 'created',
            width: 180,
        },
        {
            title: '修改时间',
            dataIndex: 'modified',
            key: 'modified',
            width: 180,
        },
        {
            title: '操作',
            dataIndex: 'id',
            width: 180,
            key:'operation',
            scopedSlots: { customRender: 'operation' },
        },
    ];
    let add_timeout;
    let update_timeout;
    let search_timeout;
    export default {
        name: 'Info',
        components: {Pics},
        data(){
            return {				
                base_url:Func.api_url,
                pic_url:Func.pic_url,
				
                columns,
                form: this.$form.createForm(this),
                keyword:'',
                tableData:[],
                loading:false,
                add_model:false,
                update_model:false,

                search_fetching: false,
                search_user_value:undefined,
                search_user_list:[],


                add_fetching: false,
                update_fetching: false,
                add_user_value:undefined,
                update_user_value:undefined,
                add_user_list:[],
                update_user_list:[],
                group_list:[],
                info_add:{
                },
                add_rules: {
                    enterprise:[{ required: true, message: '请输入企业名称', trigger: 'blur' }],
                    type:[{ required: true, message: '请输入车辆型号', trigger: 'blur' }],
                    title:[{ required: true, message: '请输入车辆名称', trigger: 'blur' }],
                },
                page:{
                    current:1,
                    total:0,
                    pageSize:10
                }
            }
        },
        mounted() {
            this.get_data();
        },
        methods: {
			carAddFunc(){
				
			},
            show_pic(data){
                this.$PubSub.publish('show_pics',data);
            },
			
			picUpdateChange(info) {
			    let fileList = [...info.fileList];
			
			    // 2. read from response and show file link
			    fileList = fileList.map(file => {
			        if (file.response) {
			            // Component will show file.url as link
			            file.url = this.pic_url+file.response.url;
			        }
			
			        return file;
			    });
			
			    console.log(fileList);
			    this.info_update.pic = fileList;
			    this.info_add.pic = fileList;
			},
			beforeUpload(file) {
			    const isLt2M = file.size / 1024 / 1024 < 200;
			    if (!isLt2M) {
			        this.$message.error('请上传200M以内文件!');
			    }
			    return isLt2M;
			},
			
            //指定用户 begin
            searchUserSearch(keyword) {
                if (search_timeout) {
                    clearTimeout(search_timeout);
                    search_timeout = null;
                }
                search_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'users.search',
                        keyword
                    },(res) => {
                        this.search_user_list = res.info.list;
                    });
                }, 300);
            },
            searchUserChange(value) {
                this.search_user_value=value;
            },


            //指定用户 begin
            addUserSearch(keyword) {
                if (add_timeout) {
                    clearTimeout(add_timeout);
                    add_timeout = null;
                }
                add_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'users.search',
                        keyword
                    },(res) => {
                        this.add_user_list = res.info.list;
                    });
                }, 300);
            },
            addUserChange(value) {
                this.info_add.uid = value;
                this.add_user_value=value;
            },
            updateReferrerSearch(keyword) {
                if (update_timeout) {
                    clearTimeout(update_timeout);
                    update_timeout = null;
                }
                update_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'users.search',
                        keyword
                    },(res) => {
                        this.update_user_list = res.info.list;
                    });
                }, 300);
            },
            updateReferrerChange(value) {
                this.info_update.uid = value;
                this.update_user_value=value;
            },
            //指定用户 end
            change_filter(pagination){
                this.get_data(pagination.current);
            },
            get_data(page,tip) {
                var keyword = this.keyword;
                if (!page) {
                    page = this.page.current||1;
                }

                if(!tip){
                    this.loading = true
                }

                Func.url_get({
                    action:'car',
                    // uid:this.search_user_value||'',
                    keyword: keyword,
                    page: page
                },(res) => {
					if (res.error === 0) {
						this.tableData = res.info.list;
						var pagination={
							pageSize:10,
							total:res.info.foot.total,
							current:parseInt(res.info.foot.current)
						}
						this.page=pagination;
						this.loading = false
					} else {
						this.$message.error(res.info);
					}
                });
            },

            add_data(e){
                e.preventDefault();
                this.$refs.add_form.validate(valid => {
                    if (valid) {
                        Func.url_post({
                            action:'car.add_data',
                            ...this.info_add,
                        },(res) => {
                            if(res.error===0){
                                this.$message.success(res.info);
                                this.add_model=false;
                                this.get_data(1,true);
                            }else{
                                this.$message.error(res.info);
                            }
                        });
                    }else{
                        return false;
                    }
                });
            },
            update_data(res){
                const item=JSON.parse(JSON.stringify(res));
                Func.url_get({
					action:'car.find_data',
                    id:item.id
                },(res) => {
                    this.info_add = res.info;
                });
				this.add_model = true;
            },

            delete_data(item){
                if(confirm('确定要删除吗')==true){
                    Func.url_get({
                        action:'car.del_data',
                        id:item.id
                    },(res) => {
                        if(res.error===0){
                            this.$message.success(res.info);
                            this.get_data(1,true);
                        }else{
                            this.$message.error(res.info);
                        }
                    });
                }
            },
            goto_url(url,id){
                this.$router.push({
                    path:'/admin/'+url,
                    params:{
                        id:id
                    }
                });
            }
        }
    }
</script>
<style lang="scss">
	.pics img{
	    max-width: 100px;
	    max-height: 100px;
	}
</style>